import setCurrentPage from "src/Utils/setCurrentPage";
import Image from "src/Common/Image";
import store from "src/Reducers/store";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_ND_DEMO_TCA_1 = {
  title:
    "Diana has been tasked on designing the\n network for Globe Connect. Here you will \nsee how Telco Cloud Automation will \nimprove her process.",
  subtitle: "Network designer",
  text: "Diana tailors network blueprints for organizations, ensuring \nefficiency, security, and future readiness across diverse \ntechnologies, protocols, and hardware.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_307"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage(previousPage());
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "631px",
            zIndex: 1,
          }}
          imagePath="ILO/TCA/TCA_ND_Demo_1_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "845px",
            height: "auto",
            bottom: "0px",
            right: "-121px",
          }}
          imagePath="ILO/characters/character_1.gif"
        />
      </div>
    </div>
  ),
};
